module.exports = __webpack_public_path__ + "img/successIcon.195de9bc.png";